import { render, staticRenderFns } from "./TransferDetailItem.vue?vue&type=template&id=0f55c76c&scoped=true"
import script from "./TransferDetailItem.vue?vue&type=script&lang=js"
export * from "./TransferDetailItem.vue?vue&type=script&lang=js"
import style0 from "./TransferDetailItem.vue?vue&type=style&index=0&id=0f55c76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55c76c",
  null
  
)

export default component.exports